import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { PerformanceWidgetPerfs } from "@tecumseh/Services/PerformanceWidgetService";
import { Draft } from "immer";

type PerformanceWidgetState = Readonly<{
    isLoadingWidgetPerf: boolean;
    widgetPerfs?: PerformanceWidgetPerfs;
    selectedComb?: any;
    performanceFilters: {
        selectedFreq?: string;
        selectedFluid?: string;
    };
    widgetPerfsData: Record<string, PerformanceWidgetPerfs>;
}>;

const initialState: PerformanceWidgetState = {
    isLoadingWidgetPerf: false,
    performanceFilters: {},
    widgetPerfsData: {},
};

const customPrintWidgetPerfs = createTypedReducerWithImmer(initialState, {
    "Custom/WidgetInfo/BeginLoadPrintWidgetPerfs": (draft: Draft<PerformanceWidgetState>) => {
        draft.isLoadingWidgetPerf = true;
    },
    "Custom/WidgetInfo/CompletePrintPerfromanceWidgetPerfs": (
        draft: Draft<PerformanceWidgetState>,
        action: { widgetPerfs: PerformanceWidgetPerfs, selectedComb: any },
    ) => {
        draft.widgetPerfs = action.widgetPerfs;
        draft.selectedComb = action.selectedComb;
        draft.isLoadingWidgetPerf = false;
    },

    "Custom/WidgetInfo/ResetPerformanceWidgetPerfs":
        (draft: Draft<PerformanceWidgetState>,
            action: { widgetPerfs: PerformanceWidgetPerfs },
        ) => {
            draft.widgetPerfs = initialState.widgetPerfs;
            draft.performanceFilters = initialState.performanceFilters;
            draft.isLoadingWidgetPerf = initialState.isLoadingWidgetPerf;
        },
});

(reducers as any).customPrintWidgetPerfs = customPrintWidgetPerfs;

export type PrintPerformanceWidgetPerfs = {
    customPrintWidgetPerfs: PerformanceWidgetState;
} & ApplicationState;

type Reducers = {
    customPrintWidgetPerfs: typeof customPrintWidgetPerfs;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;